import styled from 'styled-components';
import { Typography } from '../typography';

const Container = styled.div`
	display: flex;
	height: 100%;
	padding: 40px 0;
	flex-direction: column;
	justify-content: space-between;
`;

const Close = styled.button`
	background-color: transparent;
	position: absolute;
	top: 12px;
	right: 15px;
`;

const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	width: 100%;
	padding: 0 140px;
`;

const Tabs = styled.div`
	width: 100%;
	border: 1px solid #e6e6e6;
	border-radius: 20px;
	padding: 6px;
	flex-direction: row;
	justify-content: space-between;
`;

const Title = styled(Typography)`
	font-size: 24px;
	font-weight: 500;
	text-align: center;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Container,
	Close,
	Content,
	Tabs,
	Title,
};
